import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

// Components
import ProductSearch from './ProductSearch'
import AdminProductForm from './AdminProductForm'

class AdminProductEdit extends Component {
    render() {
        return (
            <div>
                <h1>Edit Product</h1>

                <Switch>
                    <Route path={'/admin/products/edit'} exact component={ProductSearch} />
                    <Route path={'/admin/products/edit/:permalink'} component={AdminProductForm} />
                </Switch>
            </div>
        )
    }
}

export default AdminProductEdit



// WEBPACK FOOTER //
// ./src/components/admin/products/AdminProductEdit.js